<!--accessibility-->
<div id="skiptocontent" [tabIndex]="globalConfigurationService.getAddIndexToSkiptocontent()?null:1" [ngStyle]="{visibility:isAllowedSkipNavigation?'':'hidden'}"><a href="#maincontent" id="skiptocontent_link" tabindex="0" (click)="navigateToAnchor($event)">{{'generic.accessibility_goto_main' | translate}}</a></div>

@if (layoutConfig.layout.style === 'vertical-layout-1') {
  <vertical-layout-1 ngClass="{{ brand }}" class="{{ themeColor }}"></vertical-layout-1>
}
